// Parent shell — SaaS-clean. Sidebar: Home / Children / Progress / Messages /
// Plan / Settings. All live: Home/Children/Progress (R5), Plan (R6/M7e),
// Settings (Track C — account settings, was a `soon` stub pointing at home).

import type { ReactNode } from 'react';

import { SidebarShell, type NavEntry } from '../SidebarShell';

const NAV: NavEntry[] = [
  { to: '/$locale', labelKey: 'app.nav.home', icon: '🏠' },
  { to: '/$locale/kids', labelKey: 'app.nav.kids', icon: '🧒' },
  { to: '/$locale/progress', labelKey: 'app.nav.progress', icon: '📊' },
  { to: '/$locale/messages', labelKey: 'app.nav.messages', icon: '💬' },
  { to: '/$locale/billing', labelKey: 'app.nav.plan', icon: '💳' },
  { to: '/$locale/account', labelKey: 'app.nav.settings', icon: '⚙️' },
];

export function ParentShell({ children }: { children: ReactNode }) {
  return (
    <SidebarShell titleKey="app.common.role_parent" nav={NAV}>
      {children}
    </SidebarShell>
  );
}
